import { CONFIRMATION_MESSAGE } from '@/config/brandConfig'

export const expeditedReviewConfig = {
  title: 'Expedited Review Application',
  subtitle: 'Fill out the full application to move up in line.',

  fullApplicationPrompt:
    'Would you like to fill out the full application? It will move you up in line.',

  fields: {
    dob: {
      label: 'Date of Birth',
      required: true
    },
    instagram: {
      label: 'Instagram',
      placeholder: '@username'
    },
    twitter: {
      label: 'Twitter',
      placeholder: '@handle'
    },
    snapchat: {
      label: 'Snapchat',
      placeholder: 'username'
    },
    zipCode: {
      label: 'Zip Code',
      placeholder: '90210',
      maxLength: 10
    },
    profilePicture: {
      label: 'Upload a Profile Picture',
      maxSizeMB: 5,
      acceptedTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
    },
    meetups: {
      label: 'Are you open to meet ups or travel?'
    },
    hobbies: {
      label: 'Hobbies',
      placeholder: 'What do you enjoy doing?',
      rows: 3
    },
    tenThousandQuestion: {
      label:
        'If you suddenly had an extra $10,000 this month, what would you most likely do with it?',
      placeholder: 'Tell us what you would do...',
      rows: 4
    },
    bodyType: {
      label: 'Body Type',
      options: [
        'Skinny',
        'Athletic',
        'Normal',
        'Muscular',
        'Dad bod',
        'Overweight / Plus',
        'XL'
      ] as const
    },
    heightFeet: {
      label: 'Height',
      options: [
        "5'3 (and below)",
        "5'4",
        "5'5",
        "5'6",
        "5'7",
        "5'8",
        "5'9",
        "5'10",
        "5'11",
        "6'0",
        "6'1",
        "6'2",
        "6'3",
        "6'4",
        "6'5+"
      ] as const
    },
    heightInches: {
      label: 'Inches',
      min: 0,
      max: 11,
      step: 0.1
    }
  },

  submitButton: {
    label: 'SUBMIT',
    loadingLabel: 'Submitting...'
  },

  backButton: {
    label: 'Back'
  },

  confirmationScreen: {
    title: (num: number) => `Application #${num.toLocaleString()}`,
    body: CONFIRMATION_MESSAGE,
    expediteButton: 'REQUEST FOR EXPEDITED REVIEW'
  }
}
